import React from "react";
import { useField } from "formik";
import LocationInput from "../LocationInput";

interface FormLocationInputProps {
  name: string;
  label?: string;
  id?: string;
  placeholder?: string;
  type?: string;
  labelClassName?: string;
  className?: string;
  required?: boolean;
  customElement?: React.ReactNode;
  disabled?: boolean;
  handleDetails?: (addressDetails: google.maps.places.PlaceResult) => void;
  placeType?: string[];
  searchBy?: string;
  nearByPlace?: {
    types: { type: string; need: number }[];
    radius: number;
  } | null;
  getNearByPlaces?: CallableFunction;
  selectName?: boolean;
  [key: string]: any;
}

const FormLocationInput: React.FC<FormLocationInputProps> = ({
  name,
  label,
  id,
  placeholder,
  type,
  labelClassName,
  className,
  required,
  customElement,
  disabled,
  handleDetails,
  placeType,
  searchBy,
  nearByPlace,
  getNearByPlaces,
  selectName = false,
  ...props
}) => {
  const [field, meta, helpers] = useField(name);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    helpers.setValue(e.target.value);
  };

  return (
    <LocationInput
      name={name}
      label={label}
      id={id}
      placeholder={
        placeholder &&
        placeholder.charAt(0).toUpperCase() + placeholder.slice(1).toLowerCase()
      }
      type={type}
      labelClassName={labelClassName}
      className={className}
      error={meta.touched && meta.error ? meta.error : ""}
      required={required}
      customElement={customElement}
      disabled={disabled}
      value={field.value}
      onChange={handleChange}
      onPlaceSelect={(
        selectedAddress: string,
        addressDetails: google.maps.places.PlaceResult
      ) => {
        if (selectName) {
          helpers.setValue(addressDetails?.name);
        } else {
          helpers.setValue(selectedAddress);
        }
        if (handleDetails && typeof handleDetails === "function") {
          handleDetails(addressDetails);
        }
      }}
      placeType={placeType}
      searchBy={searchBy}
      nearByPlace={nearByPlace}
      getNearByPlaces={getNearByPlaces}
      selectName={selectName}
      {...props}
    />
  );
};

export default FormLocationInput;
